export enum WrapAlignment {
  start = 1,
  end,
  center,
  spaceBetween,
  spaceAround,
  spaceEvenly,
}
